import Enums from 'utils/EnumsManager';
import { SET_FORMAT, SET_NAME, SET_REPORT_ID, RESET } from './actionTypes';

const initialState = {
  newReportId: '',
  name: '',
  format: Enums.REPORTS.FORMATS.SUMMARY,
};

const setup = (state = initialState, action) => {
  switch (action.type) {
    case SET_NAME:
      return {
        ...state,
        name: action.payload.value,
      };

    case SET_FORMAT:
      return {
        ...state,
        format: action.payload.value,
      };

    case SET_REPORT_ID:
      return {
        ...state,
        newReportId: action.payload.value,
      };

    case RESET:
      return initialState;
  

    // TODO: remove if not needed
    /**
     * Table Setup Cases
     * // TODO: find or customize a way to separate reducers but merge function returns as one reducer instead of using combineReducers
     */
    // case ADD_COLUMN:
    //   // FIXME: find a better way to update, now is just for quick dev
    //   const column = action.payload.allColumns.find(col => col.id === action.payload.columnId);
    //   return {
    //     ...state,
    //     selectedColumns: {
    //       ...state.selectedColumns,
    //       [action.payload.toZone]: [...state.selectedColumns[action.payload.toZone], column],
    //     },
    //   };

    // case REMOVE_COLUMN:
    //   return {
    //     ...state,
    //     selectedColumns: {
    //       ...state.selectedColumns,
    //       [action.payload.fromZone]: state.selectedColumns[action.payload.fromZone].filter(col => col.id !== action.payload.columnId),
    //     },
    //   };

    default:
      return state;
  }
};

export default setup;



// WEBPACK FOOTER //
// ./src/views/ReportFilters/flow/reducer.js